<script>
import firebase from 'firebase/compat/app';
const algoliasearch = require('algoliasearch');

const client = algoliasearch('1JDWEV758P', '6fbff925cf71b3753dc31ec929017145');
const index = client.initIndex('strapp_requests');

export default {
  data() {
    return {
      savedLocations: [],
      state: 'new',
      loaded: true,
      menu: false,
      searchText: '',
      avatarPic: '',
      newItems: [],
    };
  },
  methods: {
    searchbox() {
      showSearch.value = !showSearch.value;
    },

    beginSearch(searchText) {
      this.loaded = false;
      index
        .search(searchText)
        .then(({ hits }) => {
          console.log(hits);
          this.newItems = hits;
          this.loaded = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toInbox: async function (item) {
      let uid = item.userID;

      await firebase
        .firestore()
        .collection('users')
        .doc(uid)
        .get()
        .then((querySnapshot) => {
          // this.avatar =  querySnapshot.data().avatar

          console.log(querySnapshot.data());
          this.avatarPic = querySnapshot.data().avatar;
        });

      console.log('to inbox');
      localStorage.setItem('chatUser', JSON.stringify(item));
      localStorage.setItem('chatUserAvatar', this.avatarPic);
      // if (!this.userIsAuthenticated) {
      //   this.loginDialog = true;
      //   this.continueMessageLenderAfterLogin = true;
      // }
      // else {
      this.$router.push('/inbox');
      // }
    },

    changeState: function (newState) {
      this.state = newState;
    },

    clearSearch() {
      this.loaded = false;
      index
        .search('')
        .then(({ hits }) => {
          console.log(hits);
          this.newItems = hits;
          this.loaded = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },

  created() {
    this.loaded = false;
    index
      .search('')
      .then(({ hits }) => {
        console.log(hits);
        this.newItems = hits;
        this.loaded = true;
      })
      .catch((err) => {
        console.log(err);
      });

    //   this.$store
    // .dispatch('requests/loadRequests').then((response) => {
    //            console.log('loaded requests on async', response)
    //            this.newItems = response
    //            this.loaded = true
    //         })
  },
  computed: {
    // newItems() {
    //   this.loaded=false
    //   this.$store
    // .dispatch('requests/loadRequests').then((response) => {
    //            console.log('loaded requests on async', response)
    //            return response
    //            this.loaded = true
    //         })
    // },
  },
};
</script>

<template>
  <v-container class="pt-5 mb-5">
    <h1 class="font-weight-regular text-center">Item Requests</h1>

    <h3 class="font-weight-regular text-center ma-6">
      Browse through some of the items other people in your community are
      looking for. If you have the item follow the steps to list it!
    </h3>

    <v-text-field
      style="
        justify-content: center;
        width: 90%;
        margin-bottom: 24px;
        margin-left: 5%;
        margin-right: 5%;
      "
      v-model="searchText"
      color="#ababab"
      label="Search"
      placeholder="Laptops, cameras, trailers, etc... "
      variant="outlined"
      :append-icon="sWidth ? '' : 'mdi-close'"
      density="compact"
      hide-details
      @click:append="clearSearch()"
      @keydown.enter="beginSearch(searchText)"
    ></v-text-field>

    <v-row>
      <v-col cols="12">
        <div class="d-flex justify-center">
          <template v-if="state === 'new' && loaded">
            <v-row class="mx-auto" style="max-width: 1200px">
              <v-col
                v-for="item in newItems"
                :key="item.id"
                cols="12"
                sm="12"
                md="12"
              >
                <!-- START OF ITEM CARD -->
                <v-card style="border-radius: 12px; padding: 12px">
                  <v-row>
                    <v-col class="center" cols="3" sm="3" md="3">
                      <v-card
                        :height="$vuetify.breakpoint.smAndDown ? '100' : '200'"
                        :width="$vuetify.breakpoint.smAndDown ? '60' : '250'"
                        style="border-radius: 12px"
                      >
                        <v-img
                          v-if="item.images.length > 0"
                          :height="
                            $vuetify.breakpoint.smAndDown ? '100' : '200'
                          "
                          :width="$vuetify.breakpoint.smAndDown ? '60' : '250'"
                          :src="
                            item.images
                              ? item.images[0]
                              : require('@/assets/logos/logo3.svg')
                          "
                        />

                        <v-img
                          v-else
                          :height="
                            $vuetify.breakpoint.smAndDown ? '100' : '200'
                          "
                          :width="$vuetify.breakpoint.smAndDown ? '60' : '250'"
                          contain
                          style="background-size: contain !important"
                          :src="require('@/assets/logos/icon1.svg')"
                        />
                      </v-card>
                    </v-col>
                    <v-col cols="9" sm="9" md="9">
                      <v-row
                        class="center font-weight-light text-body-2 px-3 mt-1"
                      >
                        <h2 class="">
                          {{ item.created_by }} is looking for a
                          {{ item.itemName }} in {{ item.area }}
                        </h2>

                        <!-- <span>{{ item.area }}</span> -->
                      </v-row>
                      <v-row
                        class="ml-auto mr-auto center"
                        style="margin-top: 5px !important"
                      >
                        <h4 class="secondary--text mt-4">
                          {{ item.startDateText }} to {{ item.endDateText }}
                        </h4>
                      </v-row>
                      <!-- <div
                    :style="
                      $vuetify.breakpoint.smAndDown
                        ? 'max-width: 200px;'
                        : 'max-width: 250px;'
                    "
                    class="text-truncate text-body-2 black--text mb-0 mt-2"
                  >
                    {{ item.name }}
                  </div> -->

                      <v-row
                        class="ml-auto mr-auto"
                        style="margin-top: 8px !important"
                      >
                        <p class="mx-4">
                          <b>Details:</b> <br />
                          <!-- R{{ item.totalFee }} p/day -->
                          {{ item.description }}
                        </p>
                      </v-row>

                      <v-row
                        class="ml-auto mr-auto"
                        style="
                          margin-top: 8px !important;
                          width: -webkit-fill-available;
                        "
                      >
                        <v-col class="center" cols="12" sm="12" md="4" lg="4">
                          <v-card
                            class="pa-5"
                            outlined
                            style="border-radius: 13px; width: 100%"
                          >
                            <p class="subtitle-1">
                              Daily: <br />
                              <span
                                style="line-height: 25px"
                                class="font-weight-bold"
                              >
                                R{{ item.totalFee }}</span
                              >/day
                            </p>
                          </v-card>
                        </v-col>
                        <v-col class="center" cols="12" sm="12" md="4" lg="4">
                          <v-card
                            class="pa-5"
                            outlined
                            style="border-radius: 13px; width: 100%"
                          >
                            <p v-if="item.delivery" class="subtitle-1">
                              Delivery: <br />
                              <span
                                style="line-height: 25px"
                                class="font-weight-bold"
                                >Delivery Required</span
                              >
                            </p>
                            <p v-else class="subtitle-1">
                              Delivery: <br />
                              <span
                                style="line-height: 25px"
                                class="font-weight-bold"
                                >No Delivery Required</span
                              >
                            </p>
                          </v-card>
                        </v-col>
                        <v-col class="center" cols="12" sm="12" md="4" lg="4">
                          <v-btn
                            v-bind="size"
                            class="appbutton mx-1 mt-3 white--text font-weight-medium pa-8"
                            color="#b22af0"
                            rounded
                            style="font-size: 18px"
                            elevation="6"
                            @click="toInbox(item)"
                            z-index="12"
                          >
                            Message Lender<v-icon small class="ml-2"
                              >fas fa-chevron-right</v-icon
                            >
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <!-- END OF ITEM CARD -->
                </v-card>
              </v-col>
            </v-row>
          </template>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.grid {
  display: grid;
  place-items: center;
}
.clip {
  text-overflow: clip;
  white-space: nowrap;
  overflow: hidden;
}
.card {
  border-color: rgb(221, 221, 221);
}
.card:hover {
  border-color: rgb(34, 34, 34);
}
.itmcrd {
  transition: opacity 0s ease-in-out;
}
.center {
  display: grid;
  place-items: center;
}
.itmcrd:hover {
  opacity: 0.8;
}
</style>
